import { IDealerSettings } from 'pages/Shared/Dealer/Models/dealers';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { IOption, Select } from 'components/Select';
import { useTranslation } from 'react-i18next';
import { languageOptions } from 'components/Layout/Header/Language';

export interface INotificationProps {
  dealerSettings: IDealerSettings;
  handleChange: (settings: IDealerSettings) => void;
}

export const LanguageComponent = ({
  dealerSettings,
  handleChange,
}: INotificationProps) => {
  const { t } = useTranslation();
  const handleLanguageChange = async (option: IOption) => {
    handleChange({ ...dealerSettings, language: option.value });
  };

  return (
    <>
      <Row className="align-items-center">
        <Col md={3}>
          <h6 className="h6-short">
            {t('dealerManagement.settings.language')}
          </h6>
        </Col>
        <Col md={9}>
          <Select
            options={languageOptions}
            onChange={handleLanguageChange}
            value={
              dealerSettings.language &&
              languageOptions.find(
                (lang) => lang.value === dealerSettings.language
              )
            }
          />
        </Col>
      </Row>
    </>
  );
};
